<template>
  <div class="dashboard-block sales-pipeline" v-if="!booking.is_offer">
    <h2>Sales Pipeline</h2>
    <div class="form-item__row">
      <div class="form-item__field">
        <div class="input-group input-group-booking-detail">
          <span class="input-group-addon">Pipeline Status</span>
          <selectize
            v-model="pipeline_status"
            class="selectize selectize-control selectize-single"
            name="marketing_source_admin"
            :disable-delete="true"
            :options="pipelineStatusOptions"/>
        </div>
      </div>
      <div class="form-item__field">
        <div class="input-group input-group-booking-detail">
          <span class="input-group-addon">Activity Status</span>
          <selectize
            v-model="activity_status"
            class="selectize selectize-control selectize-single"
            name="marketing_source_admin"
            :disable-delete="true"
            :options="activityStatusOptions"/>
        </div>
      </div>
      <div class="form-item__field">
        <div class="input-group input-group-booking-detail">
          <span class="input-group-addon">Probability</span>
          <input
            v-model="conversion_probability"
            type="number"
            class="form-control form-control-input"
            name="marketing_source_admin"
            :disable-delete="true"/>
        </div>
      </div>
      <div class="form-item__field">
        <div class="input-group input-group-booking-detail">
          <span class="input-group-addon">Estimated Close Date</span>
          <flat-pickr
            v-model="est_close_date"
            :config="flatPickerSingleDateConfig"
            class="form-control form-control-input balls"
            placeholder="Please select a date"
            name="est_close_date"/>
        </div>
      </div>
      <div class="w-full m-t-lg m-b-lg">
        <ladda-button
          type="submit"
          class="btn btn-primary"
          :click="handleUpdateSalesPipelineCallback">
          Save Changes
        </ladda-button>
      </div>
    </div>
  </div>
</template>

<script>
import { helpers } from 'mixins/bookings'
import { notify, http } from 'utils'
import Selectize from '../ext/codium/CodiumSelectize'
import FlatPickr from 'vue-flatpickr-component'

export default {
  mixins: [helpers],

  components: {
    Selectize,
    FlatPickr
  },

  data () {
    return {
      activityStatusOptions: [
        { id: 'live', text: 'Live' },
        { id: 'not_live', text: 'Not Live' }
      ],
      pipelineStatusPercentages: {
        unvetted: 0,
        non_responsive: 10,
        needs_more_talent: 25,
        awaiting_decision: 50,
        verbally_agreed: 90
      },
      pipelineStatusOptions: [
        { id: 'unvetted', text: 'Unvetted' },
        { id: 'non_responsive', text: 'Non Responsive' },
        { id: 'needs_more_talent', text: 'Needs More Talent' },
        { id: 'awaiting_decision', text: 'Awaiting Decision' },
        { id: 'verbally_agreed', text: 'Verbally Agreed' }
      ],
      conversion_probability: 0,
      activity_status: null,
      pipeline_status: null,
      est_close_date: null
    }
  },

  props: {
    booking: {
      type: Object,
      required: true
    }
  },

  mounted () {
    this.activity_status = this.booking.activity_status
    this.pipeline_status = this.booking.pipeline_status
    this.conversion_probability = this.booking.conversion_probability
    this.est_close_date = this.booking.est_close_date
    this.$watch('pipeline_status', (newValue, oldValue) => {
      this.conversion_probability = this.pipelineStatusPercentages[newValue]
    })
  },

  computed: {
    flatPickerSingleDateConfig () {
      var userDatePref = 'd/m/Y'
      if (this.$user.date_format_preference === 'month-first') {
        userDatePref = 'M-d-Y'
      }

      return {
        altInput: true,
        altFormat: userDatePref,
        dateFormat: 'Y-m-d',
        wrap: true
      }
    }
  },

  methods: {
    handleUpdateSalesPipelineCallback () {
      return http.put(`bookings/${this.booking.id}/update_sales_pipeline`, {
        activity_status: this.activity_status,
        pipeline_status: this.pipeline_status,
        conversion_probability: this.conversion_probability,
        est_close_date: this.est_close_date
      }).then(() => {
        notify.success('Successfully saved sales pipeline changes.')
      }).catch((errors) => {
        notify.error('Sorry something has gone wrong, please try again.')
      })
    }
  }
}
</script>

<style lang="scss">
.sales-pipeline {
  .form-control {
    border: none;
    background-color: white;
  }
}

</style>
